import ButtonDesigned from '@UI-Elements/Buttons/ButtonDesigned';
import React from 'react';

interface ChartViewProps {
  viewOptions: { text: string; value: number; desc?: string }[];
  selectedValue: number;
  onSelectionChange: (value: number) => void;
}
export const ChartViewToolbar: React.FC<ChartViewProps> = ({ viewOptions, selectedValue, onSelectionChange }) => {
  return (
    <div className="flex flex-row gap-2 justify-end">
      {viewOptions.map(({ text, value, desc }, index) => (
        <div className="flex flex-col" key={index}>
          <ButtonDesigned
            style={selectedValue === value ? 'primary' : 'outline'}
            roundedValue="2xl"
            onButtonClick={() => onSelectionChange(value)}
          >
            {text}
          </ButtonDesigned>
          {desc && <p className="text-xs">{desc}</p>}
        </div>
      ))}
    </div>
  );
};
